import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { LoginModalProvider } from './context/LoginModalContext';
import { AdminLoginModalProvider } from './context/AdminLoginModalContext';
import './i18n';
import './styles/App.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <LoginModalProvider>
      <AdminLoginModalProvider>
        <App />
        <ToastContainer position="top-right" autoClose={3000} />
      </AdminLoginModalProvider>
    </LoginModalProvider>
  </AuthProvider>
);
